import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=8c943d7e&"
import script from "./PersonForm.vue?vue&type=script&lang=js&"
export * from "./PersonForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports